import { ReactComponent as DefaultSvg} from 'assets/icons/loaders/default.svg';
import { ReactComponent as RingSvg } from 'assets/icons/loaders/ring.svg';

export const loaderVariants = {
  default: DefaultSvg,
  ring: RingSvg,
};